export const projects = [
  {
    id: 1,
    title: "HMO Full Compliance Package",
    category: "HMO Compliance",
    location: "Tottenham, N17",
    image: "https://images.unsplash.com/photo-1430285561322-7808604715df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxITU8lMjBob3VzZSUyMGxhbmRsb3JkJTIwcHJvcGVydHklMjBjb21wbGlhbmNlJTIwc2FmZXR5fGVufDB8fHx8MTc4NjYzNDU4Nnww&ixlib=rb-4.1.0&q=85",
    description: "Complete electrical compliance package for 5-bedroom HMO including EICR, emergency lighting installation and testing, fire alarm system upgrade, and consumer unit replacement.",
    scope: [
      "EICR inspection with remedials",
      "Emergency lighting installation (8 fittings)",
      "Grade A fire alarm system",
      "Consumer unit upgrade with SPD"
    ],
    duration: "3 days",
    year: "2024"
  },
  {
    id: 2,
    title: "Consumer Unit Upgrade - Rental Property",
    category: "Consumer Unit",
    location: "Enfield, EN1",
    image: "https://images.unsplash.com/photo-1467733238130-bb6846885316?w=800&q=80",
    description: "Upgraded outdated fuse board to modern 14-way RCBO consumer unit with surge protection device for landlord's rental property.",
    scope: [
      "Removed old rewirable fuse board",
      "Installed 14-way RCBO consumer unit",
      "Surge protection device (SPD) fitted",
      "Full testing and certification",
      "EIC provided"
    ],
    duration: "1 day",
    year: "2024"
  },
  {
    id: 3,
    title: "Commercial EICR - Takeaway Restaurant",
    category: "Commercial",
    location: "Hackney, E8",
    image: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=800&q=80",
    description: "Comprehensive electrical inspection for commercial kitchen including 3-phase equipment testing and emergency lighting certification.",
    scope: [
      "Full commercial EICR",
      "3-phase equipment testing",
      "Emergency lighting test & certificate",
      "Kitchen equipment safety checks",
      "Digital report and certification"
    ],
    duration: "1 day",
    year: "2024"
  },
  {
    id: 4,
    title: "Full Rewire - 3 Bed Terrace",
    category: "Rewiring",
    location: "Waltham Forest, E17",
    image: "https://images.pexels.com/photos/6474350/pexels-photo-6474350.jpeg?w=800&q=80",
    description: "Complete rewire of Victorian terrace property including new consumer unit, all circuits, sockets, switches, and lighting.",
    scope: [
      "Full property rewire",
      "New consumer unit with SPD",
      "All new sockets and switches",
      "Modern LED downlights throughout",
      "Smoke alarm system",
      "Full testing and certification"
    ],
    duration: "5 days",
    year: "2023"
  },
  {
    id: 5,
    title: "Letting Agency Portfolio - 8 EICRs",
    category: "EICR",
    location: "Various, North London",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80",
    description: "Completed electrical safety inspections for letting agency's portfolio of rental properties across North London with fast turnaround.",
    scope: [
      "8 x EICR inspections",
      "Digital reports within 48 hours",
      "Priority scheduling for remedials",
      "Agency portal access for certificates",
      "Annual compliance reminders set up"
    ],
    duration: "1 week",
    year: "2024"
  },
  {
    id: 6,
    title: "Block of Flats - Emergency Lighting",
    category: "Emergency Lighting",
    location: "Haringey, N8",
    image: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&q=80",
    description: "Installation and annual certification of emergency lighting system for communal areas in residential block.",
    scope: [
      "12 emergency light fittings installed",
      "Monthly self-test fittings",
      "Full duration testing",
      "Annual certification provided",
      "Maintenance contract established"
    ],
    duration: "2 days",
    year: "2024"
  },
  {
    id: 7,
    title: "EICR with Remedials - 2 Bed Flat",
    category: "EICR",
    location: "Islington, N1",
    image: "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxlbGVjdHJpY2lhbiUyMHRlc3RpbmclMjBlbGVjdHJpY2FsJTIwaW5zcGVjdGlvbiUyMEVJQ1IlMjBjZXJ0aWZpY2F0ZXxlbnwwfHx8fDE3ODY2MzQ1ODZ8MA&ixlib=rb-4.1.0&q=85",
    description: "Electrical safety inspection identified C2 defects. Completed priority remedial works to restore compliance for landlord.",
    scope: [
      "Full EICR inspection",
      "Identified missing RCD protection",
      "Upgraded consumer unit",
      "Fixed damaged sockets",
      "Re-tested and certified compliant"
    ],
    duration: "2 days",
    year: "2024"
  },
  {
    id: 8,
    title: "Small Commercial Office Refit",
    category: "Commercial",
    location: "Wood Green, N22",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=80",
    description: "Electrical works for office refurbishment including additional circuits, data cabling containment, and LED lighting upgrade.",
    scope: [
      "Additional power circuits",
      "LED lighting throughout",
      "Emergency lighting installation",
      "Cable management and trunking",
      "Full testing and minor works certificate"
    ],
    duration: "3 days",
    year: "2024"
  }
];

export const projectCategories = [
  { name: "All Projects", value: "all" },
  { name: "EICR", value: "EICR" },
  { name: "HMO Compliance", value: "HMO Compliance" },
  { name: "Consumer Unit", value: "Consumer Unit" },
  { name: "Rewiring", value: "Rewiring" },
  { name: "Commercial", value: "Commercial" },
  { name: "Emergency Lighting", value: "Emergency Lighting" }
];